import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-item-correo',
  templateUrl: './item-correo.component.html',
  styleUrls: ['./item-correo.component.scss']
})

export class ItemCorreoComponent {
  @Input("correo") correo: string = "";
  @Output("eliminarCorreoEmitter") eliminarCorreoEmitter: EventEmitter<string> = new EventEmitter<string>();

  eliminar() {
    this.eliminarCorreoEmitter.emit(this.correo);
  }
}
